module.exports = __webpack_public_path__ + "static/img/news12.85a989c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news12.png
// module id = zL0a
// module chunks = 1